import { render, staticRenderFns } from "./uiPass.vue?vue&type=template&id=21509008"
import script from "./uiPass.vue?vue&type=script&lang=js"
export * from "./uiPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports